import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ComponentModalBase } from '@framework/base/component';

@Component({
  selector: 'app-unique-link-modal',
  templateUrl: './unique-link-modal.component.html',
  styleUrls: ['./unique-link-modal.component.css']
})
export class UniqueLinkModalComponent extends ComponentModalBase<any> {

  public rssForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder
  ) {
    super();
    this.initForm();
  }

  protected onInit(): void {
    if (this.initialState) {
      this.rssForm.controls.link.setValue(this.initialState);
    }
  }

  protected onDestroy(): void {
  }

  protected onChanges(): void {
  }

  protected onDoCheck(): void {
  }

  protected onAfterContentInit(): void {
  }

  protected onAfterContentChecked(): void {
  }

  protected onAfterViewInit(): void {
  }

  protected onAfterViewChecked(): void {
  }

  private initForm() {
    this.rssForm = this.formBuilder.group({
      link: [{value: '',disabled: true}]
    });
  }

  close() {
    this.onClose.emit();
  }

}
